module.exports = __webpack_public_path__ + "img/9506f5b678a0d1e9f2c0eae8e587d1f0.png";